import React, { Component } from "react";
import PropertyInformation from "../Shared/Information/PropertyInformation";
import { connect } from "react-redux";
import TenantInformation from "../Shared/Information/TenantInformation";
import PropertyPics from '../Shared/PropertyPics'
import Title from "../../Helpers/Title";
import { Grid, Button } from "@material-ui/core";
import LinkHelper from "../../Helpers/Link";
import { capitalize } from "../../../actions/utils";
import PasswordChange from "../../PasswordChange";

const empty = "-";
class LandlordPropertyInfo extends Component {

    translatePropsToProfile( properties ) {

        const translateArray = ( array ) => {
            if ( !array )
                return empty;
            let matches;
            if ( Array.isArray( array ) ) {
                matches = array;
            }
            else if ( typeof array === "string" ) {
                if ( array === "{}" )
                    return empty;
                const arrayRegex = /"[^"]+"/g;
                const captures = array.match( arrayRegex );
                if ( !captures )
                    matches = [array];
                else
                    matches = captures.map( m => m.substring( 1, m.length - 1 ) );
            }
            let result = "";
            for ( let i = 0; i < matches.length; i++ ) {
                result = `${result}${result ? ", " : ""}${capitalize( matches[i] )}`;
            }
            return result;
        }

        const translateRange = ( array ) => {
            const maxValue = 6;
            if ( !array )
                return empty;
            if ( !Array.isArray( array ) )
                return array;
            if ( array.length === 0 )
                return empty;
            const sorted = array.map( v => Number( v ) );
            sorted.sort( ( a, b ) => a - b );
            const ranges = [];
            var start = sorted[0];
            var end = sorted[0];
            for ( let i = 1; i < sorted.length; i++ ) {
                if ( sorted[i] !== ( end + 1 ) ) { // Start a new range if the current is "broken". As an example, when value jumps from 2 to 4 instead of continuing with 3
                    ranges.push( [start, end] );
                    start = sorted[i];
                    end = sorted[i];
                }
                else {
                    end++;
                }
            }
            ranges.push( [start, end] );
            let result = "";
            for ( let i = 0; i < ranges.length; i++ ) {
                const from = ranges[i][0];
                const to = ranges[i][1];
                if ( i === ( ranges.length - 1 ) && to === maxValue )
                    result = `${result}${result ? ", " : ""}${from}+`
                else
                    result = `${result}${result ? ", " : ""}${from === to ? from : `${from} - ${to}`}`
            }
            return result;
        }

        const result = { ...properties };
        result.industry = properties.industries;
        result.creditRating = translateArray( properties.creditRating );
        result.children = translateRange( properties.children );

        return result;
    }

    render() {
        // const { property } = this.props;
        const { announcements, selected} = this.props;
        let selectedAnnouncement;
        for ( let key in announcements ) {
            if ( announcements[key].id === selected ) {
                selectedAnnouncement = announcements[key]
                break;
            }
        }

        if ( !selectedAnnouncement ) {
            return <div/>
        }

        return (
            <div className="User-content">
                <Title bigTitle title="Property information"/>
                <Grid container direction="row" justify="space-between">
                    <TenantInformation
                        title="Provide information of your preferred tenant"
                        // TODO: Get preferred tenant profile for property
                        profile={this.translatePropsToProfile( selectedAnnouncement.properties )}
                        preferred
                    />
                    <div>
                        <LinkHelper to={`/user/edit/property/${selectedAnnouncement.properties.id}`}>
                            <Button
                                variant="outlined"
                                color="primary"
                                size="large"
                            >
                                Edit property
                            </Button>
                        </LinkHelper>
                    </div>
                </Grid>
                <PropertyPics
                    {...this.props}
                    title={'Property Pictures'}
                    residence={selectedAnnouncement && selectedAnnouncement.residence}
                />
                <PropertyInformation
                    title="Property information"
                    properties={
                        selectedAnnouncement.properties
                            ? {
                                ...selectedAnnouncement.properties,
                                residenceType: selectedAnnouncement.residence.houseType
                            }
                            : {}
                    }
                    listing
                />
                <PasswordChange/>
            </div>
        );
    }

}

const mapStateToProps = state => {
    return {
        announcements: state.landlord.announcements,
        selected: state.landlord.selectedAnnouncement,
        images: state.images
    }
}

export default connect(mapStateToProps)( LandlordPropertyInfo );